import React, { Component } from 'react';
import { connect } from 'react-redux';
import titleFeeTotal from '../../selectors/titleTotal.selector';

class TitleTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="Row Row-finalTotalRow">
        <input tabIndex="-1" className="Row-total Row-finalTotal" id="TTotalFinal" data-tooltip="Title Total" type="text" value={total} readOnly />
        <label className="Row-finalTotalLabel" htmlFor="RTotal">TITLE TOTAL</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: titleFeeTotal(state),
  };
};

export default connect(mapStateToProps)(TitleTotal);



// WEBPACK FOOTER //
// ./src/containers/titlefees/TitleTotal.js